import { NamedRoute } from "new/routing/types";

export type UpgradePlatformRouteName = 'UpgradePage' | 'UpgradePageForm';

export const upgradePlatformRoutes: NamedRoute[] = [
  { name: 'UpgradePage', path: '/dentist-new/upgrade' },
  { name: 'UpgradePageForm', path: '/dentist-new/upgrade-form' },
];
